module.exports = __webpack_public_path__ + "static/media/reimbursement_color.712b2580.png";